var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgEvent = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "#000000",
  height: "20px",
  width: "20px",
  id: "Capa_1",
  viewBox: "0 0 489.6 489.6",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M82.6,99.9c7,0,12.8-5.8,12.8-12.8V12.8c0-7-5.8-12.8-12.8-12.8S69.7,5.8,69.7,12.8V87C69.7,94,75.6,99.9,82.6,99.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191,99.9c7,0,12.8-5.8,12.8-12.8V12.8C203.8,5.8,198,0,191,0s-12.8,5.8-12.8,12.8V87C178.2,94,184,99.9,191,99.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M299,99.9c7,0,12.8-5.8,12.8-12.8V12.8C311.8,5.8,306,0,299,0s-12.8,5.8-12.8,12.8V87C286.2,94,292,99.9,299,99.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M407.4,99.9c7,0,12.8-5.8,12.8-12.8V12.8c0-7-5.8-12.8-12.8-12.8s-12.8,5.8-12.8,12.8V87C394.6,94,400.4,99.9,407.4,99.9z "
}), /*#__PURE__*/React.createElement("path", {
  d: "M445.9,51.7v35.4c0,21.4-17.1,38.5-38.5,38.5s-38.5-17.1-38.5-38.5V51.7h-31.5v35.4c0,21.4-17.1,38.5-38.5,38.5 s-38.5-17.1-38.5-38.5V51.7h-31.1v35.4c0,21.4-17.1,38.5-38.5,38.5s-38.5-17.1-38.5-38.5V51.7h-31.5v35.4 c0,21.4-17.1,38.5-38.5,38.5s-38.5-17.1-38.5-38.5V51.7H6.4v102.6h476.8V51.7H445.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.4,179.9v309.7h476.8V179.9l0,0H6.4z M125.3,433.6H65.9v-49.7h59.5v49.7H125.3z M125.3,348.9H65.9v-49.3h59.5v49.3 H125.3z M224.8,433.6h-59.1v-49.7h59.5v49.7H224.8z M224.8,348.9h-59.1v-49.3h59.5v49.3H224.8z M324.3,348.9h-59.1v-49.3h59.5 v49.3H324.3z M324.3,264.6h-59.1v-49.7h59.5v49.7H324.3z M424.1,348.9h-59.5v-49.3h59.5V348.9z M424.1,264.6h-59.5v-49.7h59.5 V264.6z"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEvent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/event.d929f75e.svg";
export { ForwardRef as ReactComponent };